// CSS
import '@/assets/css/customer-information.scss';

//Lib  

// Api   

// Constant 

// Extend
import base from '@/scripts/base';

// Component   
import DetailsAccount from "@/views/auth/DetailsAccount";
import ProfileSettings from "@/views/auth/ProfileSettings";
import InvoiceBillingSettings from "@/views/auth/InvoiceBillingSettings";
import Security from "@/views/auth/Security";
//import lazyLoadComponent from "@/scripts/lazyLoadComponent";
//import SkeletonBox from "@/components/SkeletonBoxWithoutLoading";

// Function  

export default {

  extends: base,

  components: {
    DetailsAccount,
    ProfileSettings,
    InvoiceBillingSettings,
    Security,
    // ParsecPrime : lazyLoadComponent({
    //   componentFactory: () => import("@/views/component/RentalService/ParsecPrime"),
    //   loading: SkeletonBox,
    // })
  },

  data() {
    return {
    }
  },

  created() {
  },

  methods: {
    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion  
  },
}